<template>
  <div>
    <FixedHeader :header="header" :topOnMobile="subheaderTopOnMobile" />
    <div class="page-content">
      <div v-if="isShowPageDescription" class="container page-description">
        <p>{{ pageDescription }}</p>
      </div>
      <div class="container">
        <div :class="{ 'card-wrapper': !isWithoutCardWrapper }">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import throttle from 'lodash.throttle';
import i18n from '../../i18n';
import FixedHeader from '../ui/FixedHeader.vue';
import {
  getScrollY,
  getElementHeight,
  getAvailableHeightForScroll,
} from '../../utils/BOM';

export default {
  props: ['header', 'isWithoutCardWrapper'],

  components: {
    FixedHeader,
  },

  data() {
    return {
      routePath: '',
      pageDescription: '',
      isShowPageDescription: false,
      elementOmnibarHeight: 0,
      elementSubheaderHeight: 0,
      currentScrollY: 0,
      prevScrollY: 0,
      subheaderTopOnMobile: 0,
    };
  },

  mounted() {
    // Get the height of Omnibar
    const elementOmnibar = document.querySelector('.omnibar');
    if (elementOmnibar)
      this.elementOmnibarHeight = getElementHeight(elementOmnibar);

    // Get the height of Subheader
    const elementSubheader = document.querySelector('.fixed-header');
    if (elementSubheader)
      this.elementSubheaderHeight = getElementHeight(elementSubheader);

    // Throttle scroll handler function
    this.handleThrottledScroll = throttle(this.handleScroll, 200);
    window.addEventListener('scroll', this.handleThrottledScroll);

    this.routePath = this.$route.path;

    // Add description of Comparison page, description of other pages will be added later
    if (this.routePath.match('apnic-comparison')) {
      this.pageDescription = this.tabs['apnic-comparison'].info;
      this.isShowPageDescription = true;
    }
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleThrottledScroll);
  },

  computed: {
    ...mapState(['isNarrowWidthDevice']),
    tabs() {
      const data = JSON.parse(JSON.stringify(this.$t('tabs')));
      delete data['apnic-experimental'];
      return data;
    },
    locale() {
      return i18n.locale;
    },
  },

  watch: {
    locale() {
      if (this.routePath.match('apnic-comparison')) {
        this.pageDescription = this.tabs['apnic-comparison'].info;
      }
    },
  },

  methods: {
    handleScroll() {
      if (!this.isNarrowWidthDevice) return;

      const availableHeightForScroll = getAvailableHeightForScroll();
      if (
        availableHeightForScroll <
        this.elementOmnibarHeight + this.elementSubheaderHeight
      )
        return;

      this.currentScrollY = getScrollY();

      // Check it is scrolling down or scrolling up
      const isScrollingDown = this.currentScrollY - this.prevScrollY > 8;
      const isScrollingUp = this.currentScrollY - this.prevScrollY < -8;

      // Set the top of Subheader as the minus value of its height, i.e. hide it, when scrolling down
      if (
        isScrollingDown &&
        this.currentScrollY >
          this.elementOmnibarHeight + this.elementSubheaderHeight
      ) {
        this.subheaderTopOnMobile = -this.elementSubheaderHeight;
      }

      // Set the top of Subheader as 0, i.e. display it when scrolling up
      if (isScrollingUp && this.subheaderTopOnMobile !== 0) {
        this.subheaderTopOnMobile = 0;
      }

      this.prevScrollY = this.currentScrollY;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  background-color: #f5f5f7;
  padding: 20px 0;
  min-height: calc(100vh - 110px);
}

.page-description p {
  padding: 0;
  font-size: 1.2rem;
  font-weight: 900;
  color: $text-blue;
}

.card-wrapper {
  background-color: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  padding: 30px 25px;
}
.section {
  margin-bottom: 30px;

  ul {
    list-style-type: '- ';
    list-style-position: inside;

    li {
      line-height: 32px;
    }
  }
}
h2 {
  margin-bottom: 10px;
  font-size: 28px;

  @media screen and (max-width: 485px) {
    font-size: 20px;
    line-height: 1.2;
  }
}
p {
  line-height: 1.5;
}

@include responsive(mobile) {
  .card-wrapper {
    padding: 30px 0px;
  }
}
</style>
